
import React, {FC} from 'react';
import {Markdown} from 'components/Markdown';

import * as styles from './styles.module.scss';

type FactoidProps = {
	title: string
	text: string
}

const Factoid: FC<FactoidProps> = ({title, text}) => {
	return (
		<div className={styles.wrapper}>
			<h4>{title}</h4>
			<Markdown markdown={text} />
		</div>
	);
};

export default Factoid;
